import React, { useState, useEffect } from "react";

import { 
    Button, 
    Spinner, Dropdown,
    Toaster 
} from "components";

import { func_validation, isStringEqual_caseInsensitive } from "functions";

import ic_small_save from "assets/images/ic_small_save_white.svg";
import { FormInput_text } from "components/form/formInput/FormInput_text";



export function useCompanyStatus(props) {
    const { 
        comID, isTrial, isSuspended: isSuspended_props, 
        suspendCOM_requesting,
        suspendCOM_status,

        // API Functions
        suspendCOM,
    } = props;

    let comID_validated = func_validation.isNotNullUndefined(comID)? comID: "";

    // States
    const [isSuspended, setIsSuspended] = useState(isSuspended_props);

    useEffect(() => {
        setIsSuspended(isSuspended_props);
    }, [isSuspended_props]);

    function handleUpdateCompanyStatus() {
        if (func_validation.isNumberValid(comID_validated)) {
            let isSuspendedChanged = (!isSuspended_props && isSuspended);
            if (isSuspendedChanged) {
                suspendCOM(comID_validated);
            }
            else {
                Toaster({
                    type: "info",
                    msg: "No status changed"
                })
            }
        }
        else {
            Toaster({
                type: "error",
                msg: "COM ID required"
            })
        }
    }

    let isStatusChangeDisbaled = isSuspended_props || (isSuspended && suspendCOM_status);

    let submitStatusButton = (
        <Button
            className={"distributorPortal-companyOverview-pageHeaderActions-save"}
            handleOnClick={handleUpdateCompanyStatus}
            isDisabled={isStatusChangeDisbaled}
            isDecoration_transparentDarkGreyBorder
        >
            <div className={"d-flex flex-column align-items-center justify-content-center"}>
                {suspendCOM_requesting? (
                    <Spinner size={0} isLeftMarginOptional />
                ):(
                    <img
                        src={ic_small_save}
                        alt={"Save Icon"}
                        className={"distributorPortal-companyOverview-pageHeaderActions-saveIcon"}
                    />
                )}
                <div className={"distributorPortal-companyOverview-pageHeaderActions-saveText"}>
                    Save
                </div>
            </div>
        </Button>
    );

    let statusDropdown = (
        <>
            {/* <Dropdown
                className={"distributorPortal-companyOverview-companyDetails-current-status"}
                label={"Current Status"}
                selectedValueLabel_default={isTrial}
                selectedValue_default={isTrial}
                options={[
                    {
                        label: "Trial",
                        value: "Trial",
                    },
                    {
                        label: "Active (Chargeable)",
                        value: "Active",
                    },
                ]}
                onChange={setChangeableStatus}
                selectedValueIconClassName={"distributorPortal-companyOverview-companyDetails-current-statusIcon " + 
                    (isTrial? "distributorPortal-companyOverview-companyDetails-current-statusIcon_trial":"distributorPortal-companyOverview-companyDetails-current-statusIcon_active ")}
                isSelectedValueIconVisible
            /> */}

            <div>
                {/* Label */}
                <div className={"distributorPortal-companyOverview-companyDetails-label"}>Current Status</div>

                {/* Status */}
                <div className={"distributorPortal-companyOverview-companyDetails-current-status d-flex align-items-center"}>
                    <span className={"distributorPortal-companyOverview-companyDetails-current-statusIcon " + 
                            (isTrial? "distributorPortal-companyOverview-companyDetails-current-statusIcon_trial ":"distributorPortal-companyOverview-companyDetails-current-statusIcon_active ")}/>

                    {isTrial? "Trial": "Active"}
                </div>
            </div>
            
            <Dropdown
                className={"distributorPortal-companyOverview-companyDetails-suspend-status"}
                label={"Suspend Status"}
                selectedValueLabel_default={isSuspended? "Suspended": "Not Suspended"}
                options={[
                    {
                        label: "Suspended",
                        value: true,
                    },
                    {
                        label: "Not Suspended",
                        value: false,
                    },
                ]}
                isDisabled={isStatusChangeDisbaled}
                onChange={setIsSuspended}
                disabledInputMsg={"Please request COM reactivation for COM " + comID}
            />
        </>

    );

    return [
        submitStatusButton,
        statusDropdown
    ]
}